import { BrowserModule } from '@angular/platform-browser';
import { NgModule, enableProdMode } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { AngularFireModule } from 'angularfire2';
import { RouterModule } from '@angular/router';

import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';

// Do not import from 'firebase' as you'd lose the tree shaking benefits
import * as firebase from 'firebase/app';

import { AppComponent } from './app.component';

import { LoginComponent } from './auth/login.component';
import { DateComponent } from './main/date.component';

import { UsersOnly, GuestsOnly, AuthService } from './auth/guard.service';
import { UserbarComponent } from './auth/userbar.component';

import { ListForDate } from './items/ListForDate.component';
import { WeekPicker } from './cal/WeekPicker.component';
import { ItemComponent } from './items/Item.component';
import { NewItemComponent } from './items/NewItem.component';

import { DateUtils } from './dateutils.service';

import {firebaseConfig} from './config';

import {routes} from './routes';
import { SidebarComponent } from './main/sidebar.component';
import { WeekComponent } from './main/week.component';
import { ListForWeekComponent } from './items/ListForWeek.component';

import { environment } from '../environments/environment';
import { AccountComponent } from './account/account.component';

import { TagParser } from './tags/tag-parser.service';
import { TagService } from './tags/tag.service';
import { ListForObservableComponent } from './items/ListForObservable.component';

if (environment.production) {
    enableProdMode();
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DateComponent,
    UserbarComponent,
    ListForDate,
    WeekPicker,
    ItemComponent,
    NewItemComponent,
    SidebarComponent,
    WeekComponent,
    ListForWeekComponent,
    AccountComponent,
    ListForObservableComponent,
  ],
  imports: [
    RouterModule.forRoot(routes),
    BrowserModule,
    FormsModule,
    HttpModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
  ],
  providers: [AuthService, UsersOnly, GuestsOnly, DateUtils, TagParser, TagService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/vlad/Projects/done/web/src/app/app.module.ts